/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AcceptInviteRequest
 */
export interface AcceptInviteRequest {
    /**
     * The email address that the invite was sent to
     * @type {string}
     * @memberof AcceptInviteRequest
     */
    invitedEmail: string;
}

/**
 * Check if a given object implements the AcceptInviteRequest interface.
 */
export function instanceOfAcceptInviteRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "invitedEmail" in value;

    return isInstance;
}

export function AcceptInviteRequestFromJSON(json: any): AcceptInviteRequest {
    return AcceptInviteRequestFromJSONTyped(json, false);
}

export function AcceptInviteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcceptInviteRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'invitedEmail': json['invitedEmail'],
    };
}

export function AcceptInviteRequestToJSON(value?: AcceptInviteRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'invitedEmail': value.invitedEmail,
    };
}

